import { Grid, TextField, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { dptoInsUpdSlice, selectDptoInsUpd } from "../../../redux/dpto/dptoInsUpdSlice";
import { useAppDispatch } from "../../../app/hooks";
import AvatarUploadDragAndDrop from "../../../features/base/image/AvatarUploadDragAndDrop";

export function DptoInsUpdData() {
    const dptoInsUpd = useSelector(selectDptoInsUpd);
    const dispatch = useAppDispatch();

    const changedName = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        const dpto = {
            ...dptoInsUpd.dpto
        };
        dpto.name = event.target.value;
        dispatch(dptoInsUpdSlice.actions.set(dpto));
    };

    const handleAvatarChange = (img: string) => {
        const dpto = {
            ...dptoInsUpd.dpto,
            url: img
        };
        dispatch(dptoInsUpdSlice.actions.set(dpto));
    };

    return <>
        <Typography variant="h6" gutterBottom>
            Dados da sala de aula
        </Typography>
        <Grid container spacing={3}>
            <Grid size={12}>
                <TextField required id="name" name="name" label="Nome"
                    fullWidth autoComplete="nome" variant="standard"
                    value={dptoInsUpd.dpto.name}
                    onChange={changedName} />
            </Grid>
            <Grid size={12}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    Avatar
                </Typography>
                <AvatarUploadDragAndDrop
                    value={dptoInsUpd.dpto.url || ""}
                    onChange={handleAvatarChange}
                    alt={dptoInsUpd.dpto.name}
                />
            </Grid>
        </Grid>
    </>;
}